import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["count"]
  connect() {
   addEventListener('notification:show', this.show.bind(this));
  // this.countTarget.textContent = 0;
  }
  show(event) {
    console.log(event)
    console.log(event)
    console.log(event)
    console.log(event)
    console.log(event)
    this.countTarget.textContent = 10;
  }
}
